/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import ga4 from 'tracking/src/ga4';

import MobileHeaderToggle from './MobileHeaderToggle';
import MobileMenu from './MobileMenu';

import { MobileHeaderProps } from './_props';

import useHeaderContext from '../header_deprecated/hooks/useHeaderContext';

/**
 * MobileHeader Component
 */

function MobileHeader({ menuItems, CtaButton, mobileMenuClasses, iconSize, iconClasses }: MobileHeaderProps) {
  const { isMobileMenuOpen, toggleMobileMenu } = useHeaderContext();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isMobileMenuOpen) {
      timeoutId = setTimeout(() => {
        ga4.assignEvent(process.env.NEXT_PUBLIC_GA4, 'old_topnav_viewed', {
          type: 'navbar_menu_event',
          url: document.URL,
        });
      }, 1000);
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [isMobileMenuOpen]);

  if (!menuItems) return null;

  return (
    <>
      <MobileHeaderToggle
        isMobileMenuOpen={isMobileMenuOpen}
        toggleMobileMenu={toggleMobileMenu}
        iconSize={iconSize}
        iconClasses={iconClasses}
      />

      <MobileMenu
        isMobileMenuOpen={isMobileMenuOpen}
        menuItems={menuItems}
        CtaButton={CtaButton}
        classes={mobileMenuClasses}
      />
    </>
  );
}

/**
 * Exports
 */

export default MobileHeader;
